export default "__VITE_ASSET__CLQLewJY__"